import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { buildExamTitle, compareExams, compareConvocatorias } from '../utils/examNames';

const OfficialExams = () => {
  const { oppositionName } = useParams();
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const r = await axios.get(`/api/exams/${oppositionName}`);
        setExams(r.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [oppositionName]);

  if (loading) return <div className="page-loader">Cargando exámenes…</div>;

  // Agrupar por año y, dentro del año, por convocatoria (Marzo y Septiembre de 2024 son dos convocatorias)
  const byYear = {};
  exams.forEach((e) => {
    const y = e.year || 'Sin año';
    const c = e.convocatoria || String(y);
    if (!byYear[y]) byYear[y] = {};
    if (!byYear[y][c]) byYear[y][c] = [];
    byYear[y][c].push(e);
  });
  const years = Object.keys(byYear).sort((a, b) => (b > a ? 1 : -1));

  return (
    <div>
      <button
        onClick={() => navigate(`/oposicion/${oppositionName}`)}
        className="back-link"
      >
        ← Volver
      </button>

      <header className="page-header">
        <h1 className="page-title">Exámenes oficiales</h1>
        <p className="page-subtitle">
          {oppositionName} · {exams.length} exámenes disponibles
        </p>
      </header>

      {exams.length === 0 ? (
        <div className="empty-state">
          <p>Aún no hay exámenes oficiales cargados.</p>
        </div>
      ) : (
        years.map((year) => {
          const convocatorias = Object.keys(byYear[year]).sort(compareConvocatorias);
          return (
            <div key={year} className="year-group">
              <h3 className="section-title">{year}</h3>
              {convocatorias.map((conv) => (
                <div key={conv} className="convocatoria-group">
                  {convocatorias.length > 1 && <h4 className="convocatoria-title">{conv}</h4>}
                  <div className="list-grid">
                    {[...byYear[year][conv]].sort(compareExams).map((e) => (
                      <Link
                        key={e.name}
                        to={`/exam/oficial/${encodeURIComponent(e.name)}`}
                        state={{ title: `${conv} · ${buildExamTitle(e, e.name)}` }}
                        className="list-item"
                      >
                        <div>
                          <div className="list-item-title">{buildExamTitle(e, e.name)}</div>
                          <div className="list-item-meta">
                            {e.questions} preguntas
                          </div>
                        </div>
                        <span className="list-item-arrow">→</span>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          );
        })
      )}
    </div>
  );
};

export default OfficialExams;
